import circle from '@turf/circle';
import { Colorizers } from '@leverege/ui-attributes';
import Unit from '@leverege/unit';
const getColor = (color, item, cxt) => {
  if (typeof color === 'string') {
    return color;
  }
  if (color && typeof color === 'object') {
    return Colorizers.getColor(color, item, cxt);
  }
  return null;
};
const getNumber = (num, item, cxt, dVal = null) => {
  if (typeof num === 'number') {
    return num;
  }
  if (num && typeof num === 'object') {
    return dVal; // Numberizer.getNumber( num, item, cxt )
  }
  return dVal;
};
const getPattern = (pattern, item, cxt, dVal = null) => {
  if (typeof pattern === 'string') {
    const t = pattern.trim();
    if (t.length === 0) {
      return null;
    }
    return t;
  }
  if (pattern && typeof pattern === 'object') {
    return dVal; // Value.get( num, item, cxt )
  }
  return dVal;
};
const getDashArray = (array, item, cxt, dVal = null) => {
  if (Array.isArray(array)) {
    return array;
  }
  if (array && typeof array === 'object') {
    return dVal; // Value.get( num, item, cxt )
  }
  return dVal;
};
function getAccuracyFeature(position, accuracy = {}, accuracyMultiplier = 1) {
  let {
    value
  } = accuracy;
  const {
    unit
  } = accuracy;
  if (typeof value === 'number') {
    value = Unit.convert(value, unit, 'm');
  }
  if (position?.lat && position?.lon && typeof value === 'number') {
    const c = circle([position?.lon, position?.lat], value * accuracyMultiplier, {
      units: 'meters',
      steps: 100
    });
    return c;
  }
  return null;
}
export default {
  getColor,
  getNumber,
  getPattern,
  getDashArray,
  getAccuracyFeature
};